function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 4",
    d: "M12 15.2 3.2 24 0 20.8 8.8 12 0 3.2 3.2 0 12 8.8 20.8 0 24 3.2 15.2 12l8.8 8.8-3.2 3.2z",
    style: {
      fill: "#050d17"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.1ee30c8f5b0ff6d60459020831648fc9.svg";
export { ForwardRef as ReactComponent };